import { motion } from "framer-motion";
import { ShieldCheck, Building2, LifeBuoy } from "lucide-react";

const ITEMS = [
  {
    n: "01",
    icon: ShieldCheck,
    title: "99% Visa Success Rate",
    desc: "Meticulous documentation, mock interviews, and financial evidence handled by ex-consulate advisors.",
  },
  {
    n: "02",
    icon: Building2,
    title: "50+ Partnered Universities",
    desc: "Direct access to admissions teams across Russell Group, Excellence Initiative and top polytechnic institutes.",
  },
  {
    n: "03",
    icon: LifeBuoy,
    title: "End-to-End Support",
    desc: "From course discovery to airport pick-up, accommodation, and post-landing bank & SIM setup — we're there.",
  },
];

export default function ValueProps() {
  return (
    <section
      id="why-us"
      className="relative py-24 md:py-32 bg-[#FDFDFD]"
      data-testid="why-us-section"
    >
      <div className="mx-auto max-w-[1440px] px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 mb-16 md:mb-24">
          <div className="md:col-span-4">
            <span className="section-label">CH · 01 / Why Edufly</span>
          </div>
          <div className="md:col-span-8">
            <h2 className="font-display text-[#0a192f] text-4xl sm:text-5xl md:text-6xl tracking-[-0.025em] leading-[0.98]">
              Precision advice for the{" "}
              <span className="italic font-normal">brave few</span> who refuse
              generic study-abroad templates.
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-[#0a192f]/10 border border-[#0a192f]/10">
          {ITEMS.map((it, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{
                duration: 0.7,
                delay: i * 0.12,
                ease: [0.22, 1, 0.36, 1],
              }}
              className="bg-white p-8 md:p-10 flex flex-col gap-10 group"
              data-testid={`value-prop-${i}`}
            >
              <div className="flex items-start justify-between">
                <div className="w-14 h-14 rounded-full border border-[#0a192f]/15 flex items-center justify-center group-hover:bg-[#00A3FF] group-hover:border-[#00A3FF] transition-colors">
                  <it.icon
                    size={22}
                    className="text-[#0a192f] group-hover:text-white transition-colors"
                  />
                </div>
                <span className="font-mono-tech text-xs text-[#0a192f]/50">
                  ({it.n})
                </span>
              </div>
              <div>
                <h3 className="font-display text-2xl md:text-3xl text-[#0a192f] tracking-tight leading-tight mb-4">
                  {it.title}
                </h3>
                <p className="text-[#0a192f]/70 leading-relaxed font-body">
                  {it.desc}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
